import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDirectionChevronRight16 = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M4 15.333C4.37667 11.713 9.4 8.12301 12 7.99967C9.4 7.87967 4.37667 4.28634 4 0.666341" stroke="currentColor" /></svg>;
const ForwardRef = forwardRef(SvgDirectionChevronRight16);
export default ForwardRef;